export const KIDS_MAX_SCOPE = 'kids.max';

export type KidsMaxPlanContext = {
  quotasEnforced: boolean;
  paymentsEnabled: boolean;
  scopes: Record<string, number> | undefined;
  activeChildCount: number;
};

/** Matches backend assertSeatLimit for kids.max. */
export function hasKidsMaxSeatAvailable(ctx: KidsMaxPlanContext): boolean {
  if (!ctx.quotasEnforced) {
    return true;
  }
  const limit = ctx.scopes?.[KIDS_MAX_SCOPE];
  if (limit === undefined || limit === 0) {
    return false;
  }
  if (limit < 0) {
    return true;
  }
  return ctx.activeChildCount < limit;
}

export function showKidsMaxUpgrade(
  ctx: KidsMaxPlanContext & { canAddByRole: boolean },
): boolean {
  if (!ctx.paymentsEnabled || !ctx.canAddByRole) {
    return false;
  }
  if (!ctx.quotasEnforced) {
    return false;
  }
  const limit = ctx.scopes?.[KIDS_MAX_SCOPE];
  if (limit === undefined || limit < 0) {
    return false;
  }
  return ctx.activeChildCount >= limit;
}

export function kidsMaxLimit(
  scopes: Record<string, number> | undefined,
): number | null {
  const limit = scopes?.[KIDS_MAX_SCOPE];
  if (limit === undefined || limit < 0) {
    return null;
  }
  return limit;
}
